var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2211 3C16.2031 3 17.1326 3.224 17.9606 3.623L16.3586 5.213C16.1391 5.43014 15.9648 5.68867 15.8459 5.9736C15.727 6.25854 15.6657 6.56424 15.6657 6.873C15.6657 7.18176 15.727 7.48746 15.8459 7.7724C15.9648 8.05733 16.1391 8.31586 16.3586 8.533C16.8035 8.97339 17.4043 9.22042 18.0303 9.22042C18.6564 9.22042 19.2571 8.97339 19.7021 8.533L21.1286 7.117C21.3686 7.778 21.5001 8.491 21.5001 9.234C21.5001 12.6775 18.6886 15.4685 15.2211 15.4685C14.3911 15.4685 13.5991 15.3085 12.8746 15.0185L6.53509 21.3125C6.09037 21.7529 5.48976 22 4.86384 22C4.23792 22 3.63731 21.7529 3.19259 21.3125C2.97331 21.0954 2.79924 20.837 2.68045 20.5522C2.56165 20.2674 2.50049 19.9618 2.50049 19.6532C2.50049 19.3447 2.56165 19.0391 2.68045 18.7543C2.79924 18.4695 2.97331 18.2111 3.19259 17.994L9.47609 11.755C9.1226 10.9616 8.94047 10.1026 8.94159 9.234C8.94159 5.7915 11.7531 3 15.2211 3Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/Setting_Icon.bad2fc9d2c2dbdb09e06ab66d8e0fe11.svg";
export { ForwardRef as ReactComponent };